function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.50125 15.0141C8.32638 15.0141 8.17749 15.2349 8.17749 15.4957C8.17749 15.7565 8.32638 15.9774 8.50125 15.9774H19.5929C19.7668 15.9774 19.9157 15.7565 19.9157 15.4957C19.9157 15.2349 19.7668 15.0141 19.5929 15.0141H8.50125Z",
  fill: "#333333"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6209 22.0618C14.7958 22.0618 14.9447 21.841 14.9447 21.5802C14.9447 21.3194 14.7958 21.0986 14.6209 21.0986H8.50149C8.32662 21.0986 8.17773 21.3194 8.17773 21.5802C8.17773 21.841 8.32662 22.0618 8.50149 22.0618H14.6209Z",
  fill: "#333333"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.50125 8.92913C8.32638 8.92913 8.17749 9.14996 8.17749 9.41077C8.17749 9.67157 8.32638 9.89141 8.50125 9.89141H19.5929C19.7668 9.89141 19.9157 9.67157 19.9157 9.41077C19.9157 9.14996 19.7668 8.92913 19.5929 8.92913H8.50125Z",
  fill: "#333333"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.658691 0.798828H31.1587V31.3029H0.658691V0.798828Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_0:3888)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.4843 30.2767H4.92849C3.13883 30.2767 1.68092 28.8198 1.68092 27.0291L1.65794 5.04664C1.65794 3.25498 3.11485 1.79808 4.9055 1.79808H26.889C28.6797 1.79808 30.1366 3.25498 30.1366 5.04564L30.1605 14.6614C30.1605 14.7014 30.1735 14.7364 30.1825 14.7743L30.1815 21.4783C30.1815 21.6392 30.1545 21.829 30.0986 22.0569L30.0386 22.3047H23.6244C22.1635 22.3067 20.9704 23.4009 20.9684 24.7419V30.2777C20.7306 30.3227 20.2999 30.3177 20.1331 30.3177L14.4843 30.2767ZM29.3012 23.6886C29.2033 23.8106 29.1043 23.9225 29.0034 24.0104L22.948 29.2904C22.8171 29.4044 22.6472 29.5193 22.4283 29.6422L21.9447 29.915V24.7409C21.9447 24.3182 22.1236 23.9195 22.4463 23.6177C22.7671 23.3229 23.1848 23.161 23.6244 23.161H29.7219L29.3012 23.6886ZM20.1521 31.3029C20.6827 31.3029 21.2982 31.2859 21.9697 31.0411C22.6402 30.7973 23.2467 30.4636 23.6334 30.1248L29.6879 24.6889C30.4733 24.0054 31.1588 22.5065 31.1588 21.4783V14.6644V14.6634V14.5325V11.163C31.1568 11.162 31.1538 11.161 31.1508 11.16L31.1358 5.04764C31.1358 2.7044 29.2312 0.798828 26.889 0.798828H4.9055C2.56426 0.798828 0.658691 2.7044 0.658691 5.04564L0.681674 27.0281C0.681674 29.3714 2.58724 31.2759 4.92849 31.2759H14.4843L20.1521 31.3029Z",
  fill: "#333333"
}));

var SvgFufillmentSummaryIcon = function SvgFufillmentSummaryIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0:3888",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _ref5), _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFufillmentSummaryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Fufillment_summary_icon.81424f76.svg";
export { ForwardRef as ReactComponent };